"use client";

import classnames from "classnames/bind";
import styles from "./ButtonWrapper.module.css";

const cx = classnames.bind(styles);

export const ButtonWrapper = ({
  children,
  className,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return <div className={cx("button-wrapper", className)}>{children}</div>;
};
